// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js","824":"component---src-templates-doc-js"}[chunkId] || chunkId) + "-" + {"125":"2f23d85c514816cef6cf","293":"7472190d9f1b3eae3763","454":"a6386a5b507e645e3e27","824":"20562f151b5b3ae19e4a"}[chunkId] + ".js";
};